import { BOOK_LAUNCHED } from "../book/types";
import Analytics from "../../analytics";

/**
 * If an action comes through run it through the allowlist to see if we should
 * log to Google Analytics
 */
const loggedEvents = [BOOK_LAUNCHED];
export default store => next => action => {
  if (loggedEvents.indexOf(action.type) !== -1) {
    Analytics.gaEvent(
      action.type,
      action.context,
      "index" + action.options.bookIndex
    );
    if (action.context) {
    } else {
      console.warn("Action does not have context");
    }
  }
  next(action);
};
